import { useState } from "react";

function TabButton({ label, active, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        color: active ? "#0058E5" : "#7C829A",
        fontFamily: "OpenSansRegular",
        fontSize: "14px",
        fontWeight: 600,
        lineHeight: "20px",
        letterSpacing: "0.14px",
        textTransform: "capitalize",
      }}
      className="relative py-4 text-center"
    >
      {label}
      {active && <span className="absolute left-0 -bottom-px w-full h-[2px] bg-blueColor" />}
    </button>
  );
}

const MaterialTabbar = ({ onTabChange, rightSlot }) => {
  const [activeTab, setActiveTab] = useState("Active");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  return (
    <div className="flex items-center justify-between px-5 border-b border-borderColor">
      <div className="flex items-center gap-6">
        <TabButton label="Active" active={activeTab === "Active"} onClick={() => handleTabClick("Active")} />
        <TabButton label="Archived" active={activeTab === "Archived"} onClick={() => handleTabClick("Archived")} />
      </div>
      {rightSlot}
    </div>
  );
};

export default MaterialTabbar;
